(() => {
  function init(root = document) {
    root.querySelectorAll('[data-lcs-film-tabs]').forEach(section => {
      if (section.dataset.filmTabsReady) return;
      section.dataset.filmTabsReady = 'true';
      const tabs = [...section.querySelectorAll('[role="tab"]')];
      const panels = tabs.map(tab => document.getElementById(tab.getAttribute('aria-controls')));
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let active = 0, visible = false;
      const sync = () => panels.forEach((panel, index) => {
        const video = panel.querySelector('video');
        if (!video) return;
        if (index !== active || !visible || motion.matches || document.hidden) { video.pause(); return; }
        let changed = false;
        video.querySelectorAll('source[data-src]').forEach(source => {if (!source.hasAttribute('src')) {source.src = source.dataset.src;changed = true;}});
        if (changed) video.load();
        video.play()?.catch(() => {});
      });
      const select = index => {
        active = index;
        tabs.forEach((tab, i) => {tab.setAttribute('aria-selected', String(i === index));tab.tabIndex = i === index ? 0 : -1;panels[i].hidden = i !== index;});
        sync();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', event => {
          const keys = ['ArrowLeft','ArrowRight','Home','End'];
          if (!keys.includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (active + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          select(next);tabs[next].focus();
        });
      });
      const observer = new IntersectionObserver(entries => {visible = entries.some(entry => entry.isIntersecting);sync();}, {threshold:.12});
      observer.observe(section);
      document.addEventListener('visibilitychange', sync);
      motion.addEventListener('change', sync);
      select(0);
      section.addEventListener('shopify:section:unload', () => {observer.disconnect();document.removeEventListener('visibilitychange',sync);motion.removeEventListener('change',sync);panels.forEach(panel => panel.querySelector('video')?.pause());}, {once:true});
    });
  }
  init();document.addEventListener('shopify:section:load', event => init(event.target));
})();
